import React, { useEffect } from 'react'
import Navbar from '../../components/CommonComponents/Navbar/Navbar';
import './NotFoundPage.scss'
import notFoundPageImage from '../../assets/images/not_found_page/404_compressed.png';
import birds from '../../assets/images/not_found_page/404_birds.gif';
import peek from '../../assets/images/not_found_page/404_peek.gif';

const NotFoundPage = () => {
  useEffect(() => {
    document.title = "GenieGig | 404 Not Found";
  })
  return (
    <div className='NotFoundPage'>
      <Navbar />
      <h1>OOPS !! PAGE NOT FOUND</h1>
      <div className="image">
        <img className='main_404' src={notFoundPageImage} alt='404 Not Found'></img>
        <img className='birds_404' src={birds} alt="birds" />
      </div>
      <img className="peek_404" src={peek} alt="peek" />
    </div>
  )
}

export default NotFoundPage